import { OddsType } from "../types";
import parseOdds from "./parseOdds";

export function createPromoText({ odds, bet, middleString = "Bet Wins" }: { odds: OddsType; bet: number; middleString?: string }): string {
  const parsedOdds = parseOdds(odds);
  const calculatedWin = parsedOdds.exactOdds ? bet * parsedOdds.exactOdds - bet : 0;
  const winStr = calculatedWin.toFixed(2).replace(".00", "");
  return `${odds} - $${bet} ${middleString} $${winStr}`;
}
